<template>
  <v-card flat>
    <v-expansion-panels focusable mandatory flat accordion>
      <v-expansion-panel v-for="panel in panels" :key="panel.title">
        <v-expansion-panel-header color="var(--v-primary-lighten2)">
          <h3>
            {{ panel.title }}
          </h3>
        </v-expansion-panel-header>
        <v-expansion-panel-content color="var(--v-accent-lighten3)">
          <component :is="panel.component"></component>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </v-card>
</template>

<script>
import NosePanel from "./editorPanels/NosePanel.vue";
import SkinPanel from "./editorPanels/SkinPanel.vue";
import EyesPanel from "./editorPanels/EyesPanel.vue";
import ComingSoon from "./ComingSoon.vue";
export default {
  data() {
    return {
      panels: [
        { title: "eyes", component: EyesPanel },
        { title: "nose", component: NosePanel },
        { title: "skin", component: SkinPanel },
        { title: "shape", component: ComingSoon },
        { title: "ears", component: ComingSoon },
      ],
    };
  },
};
</script>
